import { h, v as p } from "./register-Ba9sFUKZ.js";
import { f as d } from "./query-assigned-elements-CMnZBBH0.js";
import { u as c } from "./class-map-B8OdeXIO.js";
import { h as u } from "./lifecycle-decorators-C04d1yHY.js";
import { u as f } from "./showIfUsed-5lEKgJ0L.js";
import { t as E } from "./uid-DGLBmjXH.js";
var g = Object.defineProperty, v = Object.getOwnPropertyDescriptor, l = (e) => {
  throw TypeError(e);
}, s = (e, r, t, o) => {
  for (var n = o > 1 ? void 0 : o ? v(r, t) : r, a = e.length - 1, i; a >= 0; a--)
    (i = e[a]) && (n = (o ? i(r, t, n) : i(n)) || n);
  return o && n && g(r, t, n), n;
}, m = (e, r, t) => r.has(e) || l("Cannot " + t), $ = (e, r, t) => (m(e, r, "read from private field"), t ? t.call(e) : r.get(e)), S = (e, r, t) => r.has(e) ? l("Cannot add the same private member more than once") : r instanceof WeakSet ? r.add(e) : r.set(e, t), b = (e, r, t, o) => (m(e, r, "write to private field"), r.set(e, t), t);
function k(e) {
  var r;
  let t = class extends e {
    constructor() {
      super(...arguments), this.invalid = !1, S(this, r);
    }
    get errorElement() {
      return $(this, r);
    }
    set errorElement(o) {
      b(this, r, o), this.errorElement && !this.errorElement.id && (this.errorElement.id = E()), this.postSetErrorElement();
    }
    postSetErrorElement() {
    }
    handleErrorSlotchange() {
      this.errorElement = this.errorElements[0];
    }
    renderErrorTemplate() {
      const o = {
        error: !0,
        visible: this.invalid
      };
      return p`
        <${this.getScopedTag("beacon-error")} id="error" class="${c(o)}" role="alert">
          <slot name="error" @slotchange=${this.handleErrorSlotchange} ${f({ useParent: !0 })}></slot>
        </${this.getScopedTag("beacon-error")}>
      `;
    }
  };
  return r = /* @__PURE__ */ new WeakMap(), s([
    d({ flatten: !0, slot: "error" })
  ], t.prototype, "errorElements", 2), s([
    h({ type: Boolean, reflect: !0 })
  ], t.prototype, "invalid", 2), t = s([
    u("Errorable")
  ], t), t;
}
export {
  k as D
};
